import * as Moment from 'moment';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

export namespace Utils {
  export const DATE_FORMAT: string = "YYYY/MM/DD";
  export const TIME_FORMAT: string = "HH:mm";
  export const DATETIME_FORMAT: string = DATE_FORMAT + " " + TIME_FORMAT;

  // 開始／終了の日付を「YYYY/MM/DD HH:mm〜HH:mm」の形式に変換する
  export const DateTimeDisp = function (datetime1: Date, datetime2: Date): string {
    if (datetime1 != null && datetime2 != null) {
      return Moment(datetime1).format(DATETIME_FORMAT) + "〜" + Moment(datetime2).format(TIME_FORMAT);
    } else if (datetime1 != null) {
      return Moment(datetime1).format(DATETIME_FORMAT);
    } else if (datetime2 != null) {
      return Moment(datetime2).format(DATETIME_FORMAT);
    } else {
      return null;
    }
  }

  // 「YYYY/MM/DD HH:mm〜HH:mm」の形式を日付に変換する
  export const convertDateTime1 = function (datetime: string): Date {
    try {
      return new Date(datetime.substring(0, 16));
    } catch{
      return null;
    }
  }
  export const convertDateTime2 = function (datetime: string): Date {
    try {
      return new Date(datetime.substring(0, 10) + " " + datetime.substring(17, 22));
    } catch{
      return null;
    }
  }

  // id/nameの配列からidを検索してnameを返す（Selectリストで選択された名前を取得する時に使用する想定）
  export const getNameById = function (items: any[], id: number): string {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        return items[i].name;
      }
    }
    return null;
  }

  /**
   * 登録不可時間とかぶっているか判定する
   * 
   * @param newDateStart 新開始日時
   * @param newDateEnd 新終了日時
   * @param unregisterTimeStart 登録不可開始時間
   * @param unregisterTimeEnd 登録不可終了時間
   * @param dayOfTheWeek 曜日
   * @returns 登録不可時間とかぶっていない場合は true,それ以外は false
   */
  export const checkUnregistrationTime = function (newDateStart: Date, newDateEnd: Date
    , unregisterTimeStart: string, unregisterTimeEnd: string, dayOfTheWeek: string): boolean {

    //登録不可時間設定しているか判定
    if (!(unregisterTimeStart == null || unregisterTimeEnd == null || dayOfTheWeek == null)) {
      //登録不可時間設定している場合

      //曜日が一致するか判定
      if (dayOfTheWeek.indexOf(newDateStart.getDay().toString()) != -1) {
        //曜日が一致する場合

        let temp_date = newDateStart.getFullYear() + '/' + (newDateStart.getMonth() + 1) + '/' + newDateStart.getDate();
        let start = new Date(temp_date + ' ' + unregisterTimeStart);
        let end = new Date(temp_date + ' ' + unregisterTimeEnd);

        //登録不可時間設定にかぶっているか判定
        if (!((start > newDateStart && start >= newDateEnd) || (end <= newDateStart && end < newDateEnd))) {
          //登録不可時間にかぶっている場合
          return false;
        } else {
          //登録不可時間にかぶっていない場合
          return true;
        }
      } else {
        //曜日が一致しない場合
        return true;
      }
    } else {
      //登録不可時間設定していない場合
      return true;
    }
  }
}

// ngbDatepickerで使用される日付表示のカスタムフォーマッター
export class NgbDateCustomFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = Moment(value, Utils.DATE_FORMAT)
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) return '';
    let mdt = Moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return '';
    return mdt.format(Utils.DATE_FORMAT);
  }
}